<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeIndex">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeIndex">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mb-4">
                    <img :src="indexImg" class="img-index mr-2" alt="" />
                    <div class="align-middle text-left line-height-100">
                        <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                            {{ $t('bookReading.index') }}
                        </p>
                        <small class="font-size-12">Index</small>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column chapters-container" id="chapter-container">
                    <IndexItem
                        v-for="(chapter, index) of chapters"
                        :key="index"
                        :chapter_data="chapter"
                        :active="chapter.chapterNumber === currentChapter"
                    />
                </div>
            </template>
            <!-- <template v-slot:actions>
                <v-btn color="#95afad" fab small dark class="mt-5 text--white" @click="downScroll"
                    ><v-icon dark class="text--white">mdi-arrow-down</v-icon></v-btn
                >
            </template> -->
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import IndexItem from './items/IndexItem.vue'

export default {
    components: {
        UtilsContent,
        IndexItem,
    },
    computed: {
        ...mapState({
            chapters: (state) => state.bookReading.book.bookChapterDTOList,
            currentChapter: (state) => state.bookReading.currentChapter,
        }),
    },
    data() {
        return {
            indexImg: require('@/assets/img/icons/new-reading/index-purple.svg'),
            scrollPos: 0,
        }
    },
    methods: {
        downScroll() {
            const el = document.getElementById('chapter-container')
            el.scrollTop += 10
        },
        closeIndex() {
            this.$emit('close-index')
        },
    },
}
</script>
<style lang="scss">
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
    padding-right: 10px;
}
.close-btn{
  position: absolute;
  right: 24px;
  left: inherit;
  top: 16px;
  z-index: 10;
  background: #514585;
}
.close-btn.close-btn-left{
  right: 0;
  left: -14px;
  top: -14px;
}
</style>
